module.exports = __webpack_public_path__ + "static/25-b32fa0616dbdd61770a6beb8f87c9299.png";